import { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Sparkles, ArrowLeft, Loader2 } from "lucide-react";

export default function Login() {
  const { login, user, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) navigate("/dashboard");
  };

  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid="login-page">
      <header className="px-4 sm:px-6 h-16 flex items-center justify-between max-w-7xl mx-auto w-full">
        <Link to="/" className="flex items-center gap-2">
          <span className="font-display text-2xl">Ladybeauty</span>
          <Sparkles className="w-4 h-4 text-[hsl(var(--accent))]" />
        </Link>
        <Link to="/" className="text-sm text-muted-foreground inline-flex items-center gap-1 hover:text-foreground">
          <ArrowLeft className="w-4 h-4" /> Loja
        </Link>
      </header>

      <div className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md bg-white rounded-3xl lb-shadow-card p-8 lb-fade-in">
          <div className="lb-overline">Área privada</div>
          <h1 className="font-display text-3xl mt-1">Entrar</h1>
          <p className="text-sm text-muted-foreground mt-2">Acesso reservado às sócias Ladybeauty.</p>

          <form className="mt-6 space-y-4" onSubmit={submit}>
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                data-testid="login-email-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                data-testid="login-password-input"
              />
            </div>

            {error && (
              <div className="text-sm text-[hsl(var(--destructive))]" data-testid="login-error">{error}</div>
            )}

            <Button
              type="submit"
              disabled={loading}
              className="w-full rounded-full bg-[hsl(var(--primary))] hover:bg-[#A21F58] text-white h-11"
              data-testid="login-submit-btn"
            >
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              Entrar
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
